import Vue                  from 'vue';
import CookieConsent        from './cookie-consent.vue';
import Mixins               from '../../mixins/mixin';

Vue.mixin(Mixins);

new Vue({
    el: '#js-cookie-consent',
    components: {
        'cookie-consent'    : CookieConsent
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/vue/components/cookie-consent/cookie-consent.js